"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bassano-del-grappa": {
    "97b3723f": [{
      "hkey": "be1ae333",
      "slug": "bassano-del-grappa",
      "name": "Bassano del Grappa",
      "primary": true,
      "skipSearch": false
    }],
    "carbonara-ponte-storto": [{
      "hkey": "be1ae333",
      "slug": "bassano-del-grappa",
      "name": "Bassano del Grappa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "17c1aadf": [{
      "hkey": "0a8f21f2",
      "slug": "margnan-conca-d-oro",
      "name": "Margnan-Conca d'Oro",
      "primary": true,
      "skipSearch": false
    }],
    "conca-d-oro-margnan": [{
      "hkey": "0a8f21f2",
      "slug": "margnan-conca-d-oro",
      "name": "Margnan-Conca d'Oro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fc6204ef": [{
      "hkey": "ae02f90e",
      "slug": "marchesane",
      "name": "Marchesane",
      "primary": true,
      "skipSearch": false
    }],
    "roberti-rivarotta": [{
      "hkey": "ae02f90e",
      "slug": "marchesane",
      "name": "Marchesane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bassano-del-grappa"
    }],
    "5aae455e": [{
      "hkey": "5bb8b512",
      "slug": "san-bassiano",
      "name": "San Bassiano",
      "primary": true,
      "skipSearch": false
    }],
    "san-biassano": [{
      "hkey": "5bb8b512",
      "slug": "san-bassiano",
      "name": "San Bassiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;